<template>
  <div class="auth-page">
    <div class="auth-wrap">
      <img
        class="auth-logo"
        src="/images/bg/51092.jpg"
        alt="Aura Phruksa"
      />
      <div class="auth-card">
        <h2 class="auth-title">สมัครสมาชิก</h2>
        
        <Form @submit="handleRegister" :validation-schema="registerSchema" v-slot="{ errors, isSubmitting }">
          <div class="form-group">
            <label for="name" class="form-label">ชื่อ-นามสกุล</label>
            <Field
              id="name"
              name="name"
              type="text"
              class="form-input"
              :class="{ 'border-red-500': errors.name }"
              placeholder="กรอกชื่อ-นามสกุล"
            />
            <ErrorMessage name="name" class="text-red-500 text-sm mt-1" />
          </div>

          <div class="form-group">
            <label for="username" class="form-label">ชื่อผู้ใช้</label>
            <Field
              id="username"
              name="username"
              type="text"
              class="form-input"
              :class="{ 'border-red-500': errors.username }"
              placeholder="กรอกชื่อผู้ใช้"
            />
            <ErrorMessage name="username" class="text-red-500 text-sm mt-1" />
          </div>

          <div class="form-group">
            <label for="email" class="form-label">อีเมล <span class="text-gray-400 text-sm">(ไม่บังคับ)</span></label>
            <Field
              id="email"
              name="email"
              type="email"
              class="form-input"
              :class="{ 'border-red-500': errors.email }"
              placeholder="example@email.com"
            />
            <ErrorMessage name="email" class="text-red-500 text-sm mt-1" />
          </div>

          <div class="form-group">
            <label for="phone" class="form-label">เบอร์โทรศัพท์ <span class="text-gray-400 text-sm">(ไม่บังคับ)</span></label>
            <Field
              id="phone"
              name="phone"
              type="tel"
              class="form-input"
              :class="{ 'border-red-500': errors.phone }"
              placeholder="0812345678"
            />
            <ErrorMessage name="phone" class="text-red-500 text-sm mt-1" />
          </div>
          
          <div class="form-group">
            <label for="password" class="form-label">รหัสผ่าน</label>
            <Field
              id="password"
              name="password"
              type="password"
              class="form-input"
              :class="{ 'border-red-500': errors.password }"
              placeholder="กรอกรหัสผ่าน"
            />
            <ErrorMessage name="password" class="text-red-500 text-sm mt-1" />
          </div>

          <div class="form-group">
            <label for="password_confirmation" class="form-label">ยืนยันรหัสผ่าน</label>
            <Field
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              class="form-input"
              :class="{ 'border-red-500': errors.password_confirmation }"
              placeholder="กรอกรหัสผ่านอีกครั้ง"
            />
            <ErrorMessage name="password_confirmation" class="text-red-500 text-sm mt-1" />
          </div>

          <button
            type="submit"
            :disabled="isSubmitting"
            class="btn btn-primary w-full"
          >
            <span v-if="isSubmitting" class="loading-spinner" style="width: 16px; height: 16px; margin-right: 8px;"></span>
            {{ isSubmitting ? 'กำลังสมัครสมาชิก...' : 'สมัครสมาชิก' }}
          </button>
        </Form>

        <div class="auth-footer">
          มีบัญชีอยู่แล้ว?
          <router-link to="/login">เข้าสู่ระบบที่นี่</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import { useNotification } from '../composables/useNotification';

const router = useRouter();
const authStore = useAuthStore();
const { showSuccess, handleApiError } = useNotification();

const registerSchema = yup.object({
  name: yup.string().required('กรุณากรอกชื่อ-นามสกุล'),
  username: yup.string()
    .required('กรุณากรอกชื่อผู้ใช้')
    .min(4, 'ชื่อผู้ใช้ต้องมีอย่างน้อย 4 ตัวอักษร'),
  email: yup.string()
    .nullable()
    .email('รูปแบบอีเมลไม่ถูกต้อง'),
  phone: yup.string()
    .nullable()
    .test('phone-format', 'เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก', (value) => {
      if (!value || value === '') return true;
      return /^[0-9]{10}$/.test(value);
    }),
  password: yup.string()
    .required('กรุณากรอกรหัสผ่าน')
    .min(6, 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร'),
  password_confirmation: yup.string()
    .required('กรุณายืนยันรหัสผ่าน')
    .oneOf([yup.ref('password')], 'รหัสผ่านไม่ตรงกัน')
});

const handleRegister = async (values, { setErrors }) => {
  try {
    await authStore.register(values);
    showSuccess('สมัครสมาชิกสำเร็จ!');
    router.push('/');
  } catch (error) {
    handleApiError(error, setErrors);
  }
};
</script>

<style scoped>
.border-red-500 {
  border-color: #ef4444 !important;
}

.text-red-500 {
  color: #ef4444;
}

.text-sm {
  font-size: 0.875rem;
}

.mt-1 {
  margin-top: 0.25rem;
}
</style>
